import { Injectable, inject } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { getDownloadURL, getStorage, deleteObject, listAll, ref } from '@angular/fire/storage';
import { lastValueFrom } from 'rxjs';

import { ImgStorageData } from './cropper/cropper.classes';

@Injectable({
  providedIn: 'root',
})
export class MultiImagesStorageService {
  private storage = inject(AngularFireStorage);

  public async uploadImage(image: Blob, path: string) {
    const refStorage = this.storage.ref(path);
    const task = await refStorage.put(image);
    const { fullPath, bucket } = task.metadata;
    const url = await lastValueFrom(refStorage.getDownloadURL());
    const imageStorage = { url, path: fullPath, bucket };
    return imageStorage;
  }

  public async delete_directory(imagePath: string): Promise<void> {
    // WARNING!!  user very carefully could delete whatever folder
    const storage = getStorage();
    const directoryRef = ref(storage, imagePath);

    listAll(directoryRef)
      .then((res) => {
        res.items.forEach((itemRef) => {
          console.log(itemRef);
          deleteObject(itemRef);
        });
      })
      .catch((error) => {
        console.error('error al eliminar imagenes de cloud storage', error);
      });
  }
  public async deleteImage(imagePath: string): Promise<void> {
    const storageRef = this.storage.ref(imagePath);
    await storageRef.delete().subscribe((res) => {
      console.log('eliminó imagen', res);
    });
  }

  private async uploadAndGetUrl(task: AngularFireUploadTask, resolution: string): Promise<ImgStorageData> {
    const snap = await task;
    const { fullPath, bucket, name } = snap.metadata;
    const storage = getStorage();
    const storageRef = ref(storage, fullPath);
    const url = await getDownloadURL(storageRef);
    const meta: ImgStorageData = {
      url,
      fullPath,
      bucket,
      name,
      resolution,
      path: '',
      resolutions: {},
    };

    return meta;
  }
}
